export default __webpack_public_path__ + "static/media/Logo_MICHELLE-DIXON-02.541b9a0c.png";